
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-plane-line',
      title: 'Traslados Aeropuerto-Hotel',
      description: 'Recogida puntual en el aeropuerto y traslado directo a tu hotel con comodidad y seguridad.',
      features: ['Monitoreo de vuelos', 'Espera gratuita 30 min', 'Ayuda con equipaje']
    },
    {
      icon: 'ri-hotel-line',
      title: 'Traslados Hotel-Aeropuerto',
      description: 'Te llevamos de tu hotel al aeropuerto con tiempo suficiente para tu vuelo.',
      features: ['Horario personalizado', 'Confirmación previa', 'Servicio puerta a puerta']
    },
    {
      icon: 'ri-group-line',
      title: 'Transporte para Grupos',
      description: 'Camionetas espaciosas para grupos grandes, familias y eventos especiales.',
      features: ['Hasta 15 pasajeros', 'Espacio para equipaje', 'Tarifas grupales']
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Atención 24/7',
      description: 'Servicio de atención al cliente disponible las 24 horas del día, todos los días.',
      features: ['Soporte telefónico', 'WhatsApp activo', 'Emergencias cubiertas']
    },
    {
      icon: 'ri-file-text-line',
      title: 'Facturación WhatsApp',
      description: 'Recibe tu factura directamente por WhatsApp de forma rápida y sencilla.',
      features: ['Factura inmediata', 'Formato digital', 'Datos fiscales seguros']
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Conocimiento Local',
      description: 'Conductores locales que conocen perfectamente Zihuatanejo y sus alrededores.',
      features: ['Rutas optimizadas', 'Recomendaciones locales', 'Experiencia turística']
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una gama completa de servicios de transporte diseñados para hacer tu viaje 
            a Zihuatanejo lo más cómodo y sin preocupaciones posible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-lg mb-6">
                <i className={`${service.icon} text-blue-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">¿Necesitas un Servicio Especial?</h3>
          <p className="text-xl mb-8 text-blue-100">
            Contáctanos para servicios personalizados, tours, o traslados a destinos específicos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/527551234567?text=Hola, necesito información sobre servicios especiales"
              className="inline-flex items-center justify-center px-8 py-3 bg-green-600 hover:bg-green-700 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Consultar por WhatsApp
            </a>
            <a 
              href="mailto:info@transporteszihuatanejo.com?subject=Consulta sobre servicios especiales"
              className="inline-flex items-center justify-center px-8 py-3 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Enviar Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
